import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { ClearAll } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { Box } from '@mui/system'
import React from 'react'
import useSavePatient from 'src/Patient/hooks/useSavePatient'
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom'

const FormConfirmDelete = () => {
    const { handleBackStepEmailDelete, handleClickConfirmSendEmailDelete, loading } = useSavePatient()

    return (
        <div className='animate__animated animate__fadeIn'>
            <Typography variant="subtitle1" color="primary" textAlign={"center"}>
                ¡Atención!
            </Typography>

            <Typography variant="h5" color={grey[500]} mt={2} fontSize={16} textAlign={"center"}>
                ¿Está seguro de eliminar su cuenta?
            </Typography>

            <Grid container display={"flex"} justifyContent={"center"} p={1} mt={1}>
                <Box>
                    <ButtonCustom
                        color="secondary"
                        loading={loading}
                        text="Confirmar"
                        style={{ marginRight: 25 }}
                        icon={<NavigateNextIcon />}
                        onClick={handleClickConfirmSendEmailDelete}
                    />
                </Box>
                <Box>
                    <ButtonCustom
                        color="default"
                        variant="contained"
                        text="CANCELAR"
                        style={{ marginRight: 25 }}
                        icon={<ClearAll />}
                        onClick={handleBackStepEmailDelete}
                    />
                </Box>
            </Grid>
        </div>
    )
}

export default FormConfirmDelete
